import { defineMessages } from 'react-intl';

export const scope = 'app.containers.SettingsSessionPage';

export default defineMessages({
  pageTitle: {
    id: `${scope}.pageTitle`,
    defaultMessage: '{name} Settings',
  },
});
